import { render, staticRenderFns } from "./LocationDashboard.vue?vue&type=template&id=2116e15a&scoped=true&"
import script from "./LocationDashboard.vue?vue&type=script&lang=ts&"
export * from "./LocationDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./LocationDashboard.vue?vue&type=style&index=0&id=2116e15a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2116e15a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBadge,VCol,VContainer,VRow,VSpacer,VSwitch,VTab,VTabItem,VTabsItems})
